var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"id":"nose","transform":"translate(28.000000, 40.000000)","fill":"#00000","fill-opacity":"0.16"}},[_c('path',{attrs:{"d":"M16,8 C16,12.418278 21.372583,16 28,16 L28,16 C34.627417,16 40,12.418278 40,8"}})])}
var staticRenderFns = []

export { render, staticRenderFns }